import React from 'react'
import styled from 'styled-components'
import Colors from '../assets/styles/Colors'
import Rating from '@mui/material/Rating'
import Stack from '@mui/material/Stack'
// icons
import Responsive from '../assets/config/Responsive'
//
const AboutUsCard: React.FC<{
  itemTitle: string
  itemJobDescription: string
  itemBody: string
  img: string
  date: string
  startValue?: number
}> = ({ itemTitle, itemJobDescription, itemBody, img, date, startValue = 0 }) => {
  return (
    <Wrapper>
      <InfoBlock>
        <div>
          <span>{itemTitle}</span>
          <p>{itemJobDescription}</p>
          <Description>{itemBody}</Description>
        </div>
        <StarsBlock>
          <Stack spacing={1}>
            <Rating name="half-rating" defaultValue={startValue} precision={1} readOnly />
          </Stack>
          <span className="date">{date}</span>
        </StarsBlock>
      </InfoBlock>
    </Wrapper>
  )
}

// styles
const StarsBlock = styled.div`
  svg {
    color: ${Colors.primaryRed};
  }
`
const Description = styled.p`
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5; /* start showing ellipsis when 3rd line is reached */
  white-space: pre-wrap; /* let the text wrap preserving spaces */
`
// const ImageStyle = styled.img`
//   border-radius: 50%;
//   float: left;
//   border: 1px solid grey;
//   width: 50px;
//   height: 50px;
//   margin-right: 20px;
//   object-fit: contain;
// `
const Wrapper = styled.div`
  background-color: ${Colors.white};
  width: 100%;
  height: 300px;

  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: left;

  /* box shadow */
  box-shadow: 0px 0px 7px -1px rgba(0, 0, 0, 0.02);
  -webkit-box-shadow: 0px 0px 7px -1px rgba(0, 0, 0, 0.02);
  -moz-box-shadow: 0px 0px 7px -1px rgba(0, 0, 0, 0.02);
  &:hover {
    box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.02);
    -webkit-box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.02);
    -moz-box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.02);
  }

  /* responsive */
  ${Responsive.tablet} {
    width: 350px;
  }
  ${Responsive.mobile} {
    width: 300px;
    margin-left: 0;
  }
`
const InfoBlock = styled.div`
  overflow: hidden;
  height: 100%;
  cursor: default;
  padding: 50px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  span {
    color: ${Colors.primaryBlack};
    font-size: 18px;
    text-align: right;
  }

  .date {
    margin-bottom: 3px;
    font-size: 14px;
  }

  /* p descirption */
  p {
    font-size: 14px;
    color: ${Colors.SilverChalice};
    text-align: left;
    margin-bottom: 20px;
  }

  ${Responsive.mobile} {
    padding: 30px;

    /* p descirption */
    p {
      margin-bottom: 20px;
    }
  }
`

export default AboutUsCard
